<app-connection-loader *ngIf="isLoaderOpen" [bank]="selectedBank"
  [isTestBankConnector]="isTestBankConnector"></app-connection-loader>

<form class="w-full max-w-600px" (ngSubmit)="submit()" *ngIf="form && !isLoaderOpen" [formGroup]="form">
  <div class="d-flex flex-col justify-center items-center text-center">
    <img *ngIf="!isTestBankConnector" [src]="selectedBank.logo" alt="selected bank logo" class="w-78px">
    <img *ngIf="isTestBankConnector" src="/assets/images/test_bank_connector.png" alt="test bank connector logo"
      class="w-78px">
    <h1 class="my-8 font-20 font-md-24">{{ 'common_login_bank' | translate }}</h1>
    <p class="font-14 font-md-15">
      {{'common_login_subTitle'|translate}}
      <br class="d-none d-md-inline" />
      {{'common_login_subTitle2'|translate}}
    </p>
  </div>

  <div *ngIf="form.pristine && errorMessage" class="d-flex text-danger m-3">
    <span class="d-none d-md-inline picto-warning picto-size-8"></span>
    <p class="d-flex flex-col pl-md-4 m-0">
      <span class="font-bold font-15 font-md-16">
        <span class="d-inline d-md-none picto-warning"></span>
        {{'common_bank_oups'|translate}}
      </span>
      <span class="font-14 font-md-15">{{errorMessage}}</span>
    </p>
  </div>

  <div [class.container]="isOneyCustomBankConnector" class="©d-flex flex-col justify-center bg-dimwhite p-2 px-md-20 my-10">
    <ul [class.subContainer]="isOneyCustomBankConnector" class="list-none pl-0 mb-0">
      <h3 *ngIf="isOtp" class="text-center text-dark my-3">{{'common_login_confirm'|translate}}</h3>
      <li *ngFor="let field of formData.form" class="mt-3">
        <div class="form-control mb-8" [ngClass]="{
                    invalid: form.controls[field.name]?.invalid,
                    dirty: form.controls[field.name]?.dirty,
                    touched: form.controls[field.name]?.touched,
                    untouched: !form.controls[field.name]?.touched,
                    valid: form.controls[field.name]?.valid }">
          <label for="field.label">{{field.label}}</label>
          <!--Added for for linter but not knowing if I do it correctly -->

          <div *ngIf="isOneyCustomBankConnector === true; then oneyCustomBankDisplay else otherDisplay"></div>
          <ng-template #oneyCustomBankDisplay>
            <div *ngFor='let option of field.options'>
              <div class="lineContainer">
                <div class="subLineContainer">
                  <div [attr.data-content]="option.description" class="information">&#9432;</div>
                  <div>{{option.name}}</div>
                </div>
                <input class="radioButton" type="radio" [value]="option.value" [formControlName]="field.name">
              </div>
            </div>
          </ng-template>

          <ng-template #otherDisplay>
            <select *ngIf="field.type === 'list'; else otherTypes" [formControlName]="field.name" [name]="field.name">
              <option disabled hidden selected value="">{{ 'common_login_choose' | translate }}</option>
              <option *ngFor="let option of field.options" [ngValue]="option.value">{{option.name}}</option>
            </select>
            <ng-template #otherTypes>
              <input [formControlName]="field.name" [name]="field.name" [type]="field.type">
            </ng-template>
          </ng-template>
        </div>
      </li>
    </ul>

    <p *ngIf="isOtp" class="d-flex self-center text-center font-14 font-medium italic max-w-300px mt-0">
      {{'common_code_sms'|translate}}<br />{{'common_code_sms2'|translate}}
    </p>
  </div>

  <div class="d-flex justify-between">
    <button (click)="backToBankChoice()" class="btn bg-gray rounded-full px-5" type="button">
      {{ 'common_return' | translate }}
    </button>
    <button [disabled]="form && form.invalid" class="btn bg-primary rounded-full px-5" type="submit">
      <span *ngIf="!isOtp"><span class="picto-lock picto-size-5 pr-1"></span>{{ 'common_login' | translate }}</span>
      <span *ngIf="isOtp"><span class="picto-check pr-1"></span>{{ 'common_validate' | translate }}</span>
    </button>
  </div>
</form>